
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: { UiButton },
  })
  export default class CardBodyButton extends Vue {
    @Prop({ type: String, required: true }) readonly buttonText!: string;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
  }
